// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js!./form-item.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("11556735", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/form-item.css
// module id = 285
// module chunks = 0